module.exports = __webpack_public_path__ + "assets/img/handsome-man.d40a908e.jpg";